import { __decorate, __metadata } from "tslib";
import { Expose } from 'class-transformer';
import { ArrayMaxSize, IsArray, IsPositive, IsString } from 'class-validator';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { IsUndefinable } from '@goparrot/common';
export class SearchDynamicPromoCodesDto {
}
__decorate([
    Expose(),
    IsUndefinable(),
    IsArray(),
    ArrayMaxSize(100),
    IsString({ each: true }),
    ApiPropertyOptional({ type: () => String, isArray: true }),
    __metadata("design:type", Array)
], SearchDynamicPromoCodesDto.prototype, "promotionUuids", void 0);
__decorate([
    Expose(),
    IsUndefinable(),
    IsPositive(),
    ApiPropertyOptional({ type: () => Number }),
    __metadata("design:type", Number)
], SearchDynamicPromoCodesDto.prototype, "limit", void 0);
__decorate([
    Expose(),
    IsUndefinable(),
    IsString(),
    ApiPropertyOptional({ type: () => String }),
    __metadata("design:type", String)
], SearchDynamicPromoCodesDto.prototype, "cursor", void 0);
//# sourceMappingURL=SearchDynamicPromoCodesDto.js.map